import { zodResolver } from '@hookform/resolvers/zod';
import React, { useEffect, useState } from 'react';
import { useForm, useController, useFormState, Controller, SubmitHandler } from 'react-hook-form';
import { useLocation, useSearch } from 'wouter';
import { z } from 'zod';

import { FormChangePassword } from './Components/FormChangePassword';
import { FormForgotPassword } from './Components/FormForgotPassword';
interface PasswordRequestProps {
    name?: string;
}
export const PasswordRequest = (PasswordRequestProps) => {
    // const [location, setLocation] = useLocation();
    const searchString = useSearch();
    const params = new URLSearchParams(searchString);
    const info = params.get('info');
    return <>{info ? <FormChangePassword info={info} /> : <FormForgotPassword />}</>;
};
